import React from "react";
import { useStockCheckModel } from "../stockCheckModel";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useDictModel } from "@/views/base/dict/dictModel";
import { DictCodeEnmu } from "@/types/VrmSaDictEnums"
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

const PageHeaderTitle = <>
    <span style={{ color: "#7F7F7F" }}>仓库管理 </span>
    <span style={{ color: "#000" }}>/ 库存盘点</span>
</>
export function PageHeader() {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const PageHeaderTitle = <>
        <span style={{ color: "#7F7F7F" }}>{Locale["Warehouse Management"]} </span>
        <span style={{ color: "#000" }}>/ {Locale["Stocktaking"]}</span>
    </>
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useStockCheckModel();
    const { getSelectedDictOne } = useDictModel();
    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            // placeholder: "盘库单号",
            placeholder: Locale["Stocktaking Doc No."],
            fieldName: "stocktakingCode"
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "盘点状态",
            placeholder: Locale["Stocktaking status"],
            fieldName: "status",
            options: getSelectedDictOne(DictCodeEnmu.STOCKTAKING)
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "单据类型",
            placeholder: Locale["Document  Type"],
            fieldName: "type",
            options: [{ label: Locale["initialization Doc"], value: "0" }, { label: Locale["Stocktaking Doc"], value: "1" }],
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "盘点结果",
            placeholder: Locale["Result"],
            fieldName: "result",
            options: [{ label: "盘盈", value: "盘盈" }, { label: "盘亏", value: "盘亏" }, { label: "相符", value: "相符" }],
        },
        {
            type: SearchTypeEnum.Select,
            // placeholder: "盘盈单据",
            placeholder: Locale["Stocktaking Surplus Doc"],
            fieldName: "toc",
            options: [{ label: Locale["Stocktaking Surplus Doc"], value: "01" }, { label: Locale["Stocktaking Loss Doc"], value: "02" }]
        }
    ]
    return (
        <YhPageHeader
            title={PageHeaderTitle}
            triggerSearch={true}
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            handleSearch={loadData}
            handleReset={resetSearchParam}
        />
    );
}